// client/src/components/Admin/Dashboard/_shared/GlobalsLineChart.js
//
// M06 Fase 5 - Grafica de evolucion mensual de usuarios globales del
// dashboard admin. Recibe `timeseries` (objeto { "2024": [{month,count}x12], ...})
// y `yearsIndex` desde globals.users.timeseries del endpoint /overview.

import React, { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import { Line } from "@ant-design/charts";
import styles from "./GlobalsLineChart.module.scss";

const MONTH_LABELS = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

function pickInitialYear(years) {
  if (!years || years.length === 0) return undefined;
  const current = new Date().getFullYear();
  if (years.includes(current)) return current;
  return years[years.length - 1];
}

export function GlobalsLineChart({
  timeseries = {},
  yearsIndex = [],
  height = 280,
}) {
  const years = useMemo(() => {
    const fromIndex = (Array.isArray(yearsIndex) ? yearsIndex : [])
      .map((n) => Number(n))
      .filter((n) => Number.isFinite(n));
    const fromKeys = Object.keys(timeseries || {})
      .map((k) => Number(k))
      .filter((n) => Number.isFinite(n));
    return Array.from(new Set([...fromIndex, ...fromKeys])).sort(
      (a, b) => a - b,
    );
  }, [timeseries, yearsIndex]);

  const [year, setYear] = useState(() => pickInitialYear(years));
  useEffect(() => {
    setYear((prev) => (years.includes(prev) ? prev : pickInitialYear(years)));
  }, [years]);

  const data = useMemo(() => {
    const rows =
      year && Array.isArray(timeseries?.[year]) ? timeseries[year] : [];
    return rows.map((p, i) => ({
      month: MONTH_LABELS[(p.month - 1 + 12) % 12] || String(i + 1),
      value: Number(p.count ?? p.value ?? 0),
    }));
  }, [timeseries, year]);

  const config = {
    data,
    xField: "month",
    yField: "value",
    smooth: true,
    height,
    point: { size: 3 },
    tooltip: { showMarkers: true },
    color: "#2b323f",
    legend: false,
  };

  return (
    <div className={styles.globalsLineChart}>
      {years.length > 0 ? (
        <div className={styles.yearSelector}>
          <span>Anio:</span>
          <Select
            size="small"
            value={year}
            onChange={setYear}
            options={years.map((y) => ({ label: y, value: y }))}
            style={{ width: 100 }}
          />
        </div>
      ) : null}
      {data.length === 0 ? (
        <div className={styles.empty}>Sin datos para el anio seleccionado</div>
      ) : (
        <Line {...config} />
      )}
    </div>
  );
}
